import { useI18n } from '@udemy/i18n';
import classNames from 'classnames';
import React from 'react';
import styles from "./meter.module.css";
/** React props interface for the `Meter` component */

/**
 * The Meter component is modeled after the HTML5 <meter /> tag:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meter
 *
 * @privateRemarks
 *
 * We are not actually rendering a <meter /> HTML tag because it is
 * difficult to style.
 */
export const Meter = _ref => {
  let {
    value,
    min,
    max,
    label,
    className,
    ...htmlProps
  } = _ref;
  const {
    interpolate
  } = useI18n(); // min must not be greater than max

  min = min > max ? max : min; // value should be within the min-max range

  value = Math.min(Math.max(value, min), max); // avoid division by zero

  const percent = min === max ? 0 : Math.round((value - min) / (max - min) * 100); // eslint-disable-next-line @typescript-eslint/naming-convention

  const fillStyle = {
    '--scale-x': `${percent / 100}`
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, htmlProps, {
    className: classNames(className, 'ud-meter-wrapper', styles['meter-wrapper'])
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('ud-meter', styles.meter),
    style: fillStyle,
    "aria-label": interpolate(label, {
      value,
      min,
      max,
      percent
    }, true),
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    "data-purpose": "meter",
    role: "meter"
  }));
};
//# sourceMappingURL=meter.react-component.js.map